import React from 'react';
import {showDivBasedOnId,hideDivBasedOnId} from "../../commons/ui-commons";
import getStageValueOnLoad from "../services/life-cycle-management";
import {isFirstLevelApiShown,isSecondLevelApiShown,isThirdLevelApiShown} from "../services/life-cycle-management";
import {
    addSpacesBeforeCaps,
    replaceSpace,
    replaceUnderscoreWithSpace,
    setWindowLocationHash,
    titleCase,
    replaceOrUpdateBrandName,
    updateLinksInDescription
} from '../../libs/common-library';
import $ from "jquery";
import {getCustomHeaders, getDeprecatedProductsList, getLHSReducerData, getPrerequisitesFlag} from '../reducers/lhs-reducer';
import {putDataInDevCenterDataStore} from '../../app/store';
import '../css/lhs.css';
import LoadJsonData from '../../rhs/dynamic/actions/rhs-schema-actions';
import { getIsRequestDescriptionExpanded } from '../../rhs/dynamic/reducers/rhs-schema-reducer';
import { getPartnerName, getPartnerFullName } from '../reducers/configuration-reducer';
import { getCybsProductMapJson, getPartnerProductMapJson, getCybsMisMatchedProductJson } from '../reducers/lhs-reducer';

var secondLevelKeyMap = {};
// function to get first level json details
function getContentDetailsFromLHSJsonAndPopulateDataStore(isLHSNavigated,lhsContents,id)
{
    var firstLevelIterator = 0;
    var secondlevelIterator = 0;
    var thirdLevelIterator = 0;
    var thirdLevelMainProduct = 0;
    var thirdLevelItemHolder = 0;
    var firstLevelKeyFlag = new Boolean(false);
    var thirdLevelKeyFlag = new Boolean(false);
    var multipleSecondLevelKeyFlag = new Boolean(false);
    let isSuperCategoryProduct = false;
    let idx;
    for(;firstLevelIterator<lhsContents.length ;firstLevelIterator++)
    {
        if(lhsContents[firstLevelIterator]["id"] === id)
        {
            firstLevelKeyFlag = true;
            multipleSecondLevelKeyFlag = checkForMultipleSecondLevelKeys(lhsContents[firstLevelIterator]["items"], lhsContents[firstLevelIterator]["items"][0]["header"]);
            break;
        } else if (lhsContents[firstLevelIterator].items && lhsContents[firstLevelIterator].items.find(obj => obj.id === id)){
            firstLevelKeyFlag = true;
            idx = lhsContents[firstLevelIterator].items.findIndex(obj => obj.id === id);
            multipleSecondLevelKeyFlag = checkForMultipleSecondLevelKeys(lhsContents[firstLevelIterator]["items"][idx]["items"], lhsContents[firstLevelIterator]["items"][idx]["items"][0]["header"]);
            isSuperCategoryProduct = true;
            break;
        }
    }

    // check if value is present in third level key
    if(!(firstLevelKeyFlag.valueOf()))
    {
        for(var iterator = 0;iterator<lhsContents.length ;iterator++)
        {
            if(lhsContents[iterator]["items"] != undefined)
            {
                for(var mainItems = 0; mainItems<lhsContents[iterator]["items"].length;mainItems++)
                {
                    for(let items=0; items<lhsContents[iterator]["items"][mainItems]["items"].length; items++){
                        if(lhsContents[iterator]["items"][mainItems]["items"][items]["id"] == id)
                        {
                            thirdLevelKeyFlag = true;
                            thirdLevelIterator = iterator;
                            thirdLevelMainProduct = mainItems;
                            thirdLevelItemHolder = items;
                            multipleSecondLevelKeyFlag = checkForMultipleSecondLevelKeys(lhsContents[iterator]["items"][mainItems]["items"],lhsContents[iterator]["items"][mainItems]["items"][items]["header"]);
                            break;
                        }
                    }

                }
                if(thirdLevelKeyFlag.valueOf() == true)
                {
                    break;
                }
            }
        }
    }
    // lhs contents for first level
    var requiredObj, newHash;
    var partnerName = getPartnerName();
    if(lhsContents[firstLevelIterator] != undefined && (firstLevelKeyFlag.valueOf()))
    {
        if(isSuperCategoryProduct) {
            requiredObj = lhsContents[firstLevelIterator]["items"][idx]["items"][secondlevelIterator];
        } else {
            requiredObj = lhsContents[firstLevelIterator]["items"][secondlevelIterator];
        }
        requiredObj["secondLevelKeyFlag"] = multipleSecondLevelKeyFlag;
        if(isLHSNavigated){
            //In case of first level navigation, add first level family to URL
            newHash = requiredObj.firstLevelkey.toLowerCase().replaceAll('_','-');
            setWindowLocationHash(newHash);
        }
        storeLHSDataStoreContents(requiredObj);
    }
    else if(thirdLevelKeyFlag.valueOf()){
        requiredObj = lhsContents[thirdLevelIterator]["items"][thirdLevelMainProduct]["items"][thirdLevelItemHolder]
        requiredObj["secondLevelKeyFlag"] = multipleSecondLevelKeyFlag;
        if(isLHSNavigated){
            //In case of third level navigation, add first, second and third level family to URL
            newHash = requiredObj.firstLevelkey.toLowerCase().replaceAll('_','-')+'_'+requiredObj.header.toLowerCase().replaceAll(' ','-')+'_'+requiredObj.id.toLowerCase().replaceAll(' ','-');
            setWindowLocationHash(newHash);
        }
        if(requiredObj["description"] != undefined) {
            requiredObj["description"]= requiredObj["description"].replace('https://developer.cybersource.com/api/developer-guides/dita-payments/GettingStarted.html',`/docs/${partnerName}/en-us/payments/developer/all/rest/payments.html`);
            requiredObj["description"]= updateLinksInDescription(requiredObj["description"], partnerName);
        }
        storeLHSDataStoreContents(requiredObj);
    }
}

// store LHSDataStoreContents
function storeLHSDataStoreContents(skeletonItems)
{
    putDataInDevCenterDataStore({type:'UPDATE_FIRST_LEVEL_KEY',firstLevelKey:skeletonItems["firstLevelkey"]});
    putDataInDevCenterDataStore({type:'UPDATE_SECOND_LEVEL_KEY',secondLevelKey:skeletonItems["header"]});
    putDataInDevCenterDataStore({type:'UPDATE_SUMMARY',summary:skeletonItems["title"].props.children});
    putDataInDevCenterDataStore({type:'UPDATE_METHOD_TYPE',methodType:skeletonItems["methodType"]});
    putDataInDevCenterDataStore({type:'UPDATE_PATH',path:  skeletonItems["path"]});
    putDataInDevCenterDataStore({type:'UPDATE_DESCRIPTION',description:skeletonItems["description"]});
    putDataInDevCenterDataStore({type:'UPDATE_HAS_BODY_PARAMS',hasBodyParams:skeletonItems["hasBodyParams"]? true: false});
    putDataInDevCenterDataStore({type:'UPDATE_DISABLE_PROCESSOR_DROPDOWN',disableProcessorDropDown:skeletonItems["disableProcessorDropDown"]});
    putDataInDevCenterDataStore({type:'UPDATE_DISABLE_MERCHANT_CREDS',disableMerchantCreds:skeletonItems["disableDefaultMerchantCreds"]});
    putDataInDevCenterDataStore({type:'UPDATE_JSON_SOURCE',jsonSource:skeletonItems["jsonSource"]});
    putDataInDevCenterDataStore({type:'UPDATE_AUTHORIZATION_TYPE',authorizationType:skeletonItems["authorizationType"]});
    putDataInDevCenterDataStore({type:'UPDATE_NO_AUTH',noAuth:skeletonItems["noAuth"]? skeletonItems["noAuth"]: false});
    putDataInDevCenterDataStore({type:'UPDATE_IS_CLIENT_SIDE_API',isClientSideApi:skeletonItems["isClientSideApi"] ? skeletonItems["isClientSideApi"]: false });
    putDataInDevCenterDataStore({type:'UPDATE_SECOND_LEVEL_KEY_FLAG', secondLevelKeyFlag: skeletonItems["secondLevelKeyFlag"]});
    putDataInDevCenterDataStore({type:'UPDATE_IS_JSTREE_EXPANSION_LIMITED', isJstreeExpansionLimited: skeletonItems["isJstreeExpansionLimited"] ? skeletonItems["isJstreeExpansionLimited"] : false});
    putDataInDevCenterDataStore({type:'UPDATE_X_API_DEPENDENCIES',xApiDependencies:skeletonItems["xApiDependencies"] ? skeletonItems["xApiDependencies"]: undefined});
    putDataInDevCenterDataStore({type:'UPDATE_PREREQUISITES_FLAG',prerequisitesFlag: (getPrerequisitesFlag() == undefined) ?  false: getPrerequisitesFlag()});

    if("enableDownload" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_ENABLE_DOWNLOAD',enabledDownload:skeletonItems["enableDownload"]});
    }
    if("x-custom-headers" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS',customHeaders:skeletonItems["x-custom-headers"]});
        putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS_SELECTED_VALUE',customHeadersSelectedValue:undefined});
        putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS_COUNTER',customHeadersCounter:undefined});
    }
    if("sendDisabled" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_SEND_DISABLED',sendDisabled:skeletonItems["sendDisabled"]});
    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_SEND_DISABLED',sendDisabled:undefined});
    }
    if("firstLevelApiLifeCycle" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_FIRST_LEVEL_API_LIFE_CYCLE',firstLevelApiLifeCycle:skeletonItems["firstLevelApiLifeCycle"]});
    }
    if("secondLevelApiLifeCycle" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_SECOND_LEVEL_API_LIFE_CYCLE',secondLevelApiLifeCycle:skeletonItems["secondLevelApiLifeCycle"]});
    }
    if("apiLifeCycle" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_THIRD_LEVEL_API_LIFE_CYCLE',thirdLevelApiLifeCycle:skeletonItems["apiLifeCycle"]});
    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_THIRD_LEVEL_API_LIFE_CYCLE',thirdLevelApiLifeCycle:undefined});
    }
    if("overrideMerchantCredential" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_OVERRIDE_CREDENTIALS',overrideMerchantCredential:skeletonItems["overrideMerchantCredential"]});

    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_OVERRIDE_CREDENTIALS',overrideMerchantCredential:undefined});
    }
    if("disableDefaultMerchantCreds" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_DISABLE_DEFAULT_MERCHANT_CREDENTIALS',disableDefaultMerchantCreds:skeletonItems["disableDefaultMerchantCreds"]});

    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_DISABLE_DEFAULT_MERCHANT_CREDENTIALS',disableDefaultMerchantCreds:undefined});
    }
    if("disableProcessorDropdown" in skeletonItems)
    {
        putDataInDevCenterDataStore({type:'UPDATE_DISABLE_PROCESSORDROPDOWN',disableProcessorDropdown:skeletonItems["disableProcessorDropdown"]});
    }
}

// function to get host name from the given url
function getHostName()
{
    var hostName = encodeURI(window.location.hostname);
    return hostName;
}
// get lhs based on host name
function getLHSBasedOnHostName()
{
    var partnerName = getPartnerName();
    var fileName = partnerName + "_lhs.json";
    return fileName;
}


function navigateToSections(isLHSNavigated,lhsContents,id)
{
    var expandedElements = document.getElementsByClassName("rct-icon-expand-open");
    for(var i=expandedElements.length-1; i>=0; i--){

        if(expandedElements[i].parentElement){
            expandedElements[i].parentElement.click();
        }
    }
    switch (id)
    {
        case "static-home-section":
        {
            hideDivBasedOnId("dynamic-rhs");
            hideDivBasedOnId("static-api-endpoints-section");
            $('.vds-card--content--mini').addClass('border_color_theme_primary_bottom_shadow');
            showDivBasedOnId("static-home-section");

            if(isLHSNavigated){
                setWindowLocationHash(id);
            }
            break;
        }
        case "static-api-endpoints-section":
        {
            hideDivBasedOnId("dynamic-rhs");
            hideDivBasedOnId("static-home-section");
            showDivBasedOnId("static-api-endpoints-section");
            if(isLHSNavigated){
                setWindowLocationHash(id);
            }
            break;
        }
        default:
        {
            hideDivBasedOnId("static-api-endpoints-section");
            hideDivBasedOnId("static-home-section");
            showDivBasedOnId("dynamic-rhs");
            getContentDetailsFromLHSJsonAndPopulateDataStore(isLHSNavigated,lhsContents,id);
            //break;
        }
    }
}
function checkForMultipleSecondLevelKeys(lhsItemList, secondLevelKey){
    for(var index=0; index<lhsItemList.length; index++){
        if(lhsItemList[index]["header"] != secondLevelKey){
            return false;
        }
    }
    return true;
}

function clearResponseFields(){
    putDataInDevCenterDataStore({type: 'UPDATE_IS_RESPONSE_ACTIVATED',isResponseActivated:false});
    putDataInDevCenterDataStore({type: 'UPDATE_RESPONSE_CODE', responseCode: undefined})
    putDataInDevCenterDataStore({type: 'UPDATE_RESPONSE_CONTENT', responseContent: undefined})
    putDataInDevCenterDataStore({type: 'UPDATE_RESPONSE_HEADERS', responseHeaders: undefined})
    if(getIsRequestDescriptionExpanded()){
        putDataInDevCenterDataStore({type: 'UPDATE_IS_REQUEST_DESCRIPTION_EXPANDED', isRequestDescriptionExpanded: !getIsRequestDescriptionExpanded()});
    }
    putDataInDevCenterDataStore({type: 'UPDATE_IS_REQUEST_DESCRIPTION_EXPANDED', isRequestDescriptionExpanded: false});
    hideDivBasedOnId('expanded-request-field-descriptions');
}

// function get LHS json data from relevant json format and pass on the required data to other files
function getLHSJsonData(customData,menuGroupsResponse,lhsContents,isWidgetUseCase) {
    if(menuGroupsResponse!= undefined) {
        var stage = getStageValueOnLoad();
        var firstLevelKeys = Object.keys((menuGroupsResponse));
        var partnerName = getPartnerName();
        var partnerFullName = getPartnerFullName();
        var deprecatedProductsList = getDeprecatedProductsList();
        var cybsProductMapJson, partnerProductMapJson, cybsMisMatchedProductJson;
        var superSet = {};
        const productCategoriesList = require('../../superProductCategories.json');
        for (var i = 0; i < firstLevelKeys.length; i++) {
            if(isFirstLevelApiShown(firstLevelKeys[i],stage,menuGroupsResponse,isWidgetUseCase))
            {
                var customItem = {};
                customItem["id"]=replaceSpace(firstLevelKeys[i]).replaceAll("_","-");
                customItem["title"] = titleCase(replaceUnderscoreWithSpace(replaceSpace(firstLevelKeys[i])));

                if (deprecatedProductsList && Object.values(deprecatedProductsList).filter(value => value === customItem["title"]).length != 0) {
                    continue;
                }

                if (partnerName !== "cybs"){
                    cybsProductMapJson = getCybsProductMapJson();
                    partnerProductMapJson = getPartnerProductMapJson();
                    // cybsMisMatchedProductJson variables and logic will be removed when this Mismatched Product Family Names are changed in SPEC
                    cybsMisMatchedProductJson = getCybsMisMatchedProductJson();
                    if (cybsProductMapJson && partnerProductMapJson) {
                        var productShortName = Object.keys(cybsProductMapJson).find(key => cybsProductMapJson[key] === customItem["title"]);
                        if (!productShortName && cybsMisMatchedProductJson) {
                            productShortName = Object.keys(cybsMisMatchedProductJson).find(key => cybsMisMatchedProductJson[key] === customItem["title"]);
                        }
                        var mainProdShortName = productShortName && productShortName.includes("--") ? productShortName.split("--")[0] : undefined;
                        if ((!mainProdShortName && productShortName && partnerProductMapJson.hasOwnProperty(productShortName)) ||
                            (mainProdShortName && productShortName && partnerProductMapJson.hasOwnProperty(mainProdShortName) && partnerProductMapJson.hasOwnProperty(productShortName))) {
                            customItem["title"] = partnerProductMapJson[productShortName];
                        } else {
                            continue;
                        }
                    }
                }

                customItem["icon"] = 'account-favorite';
                customItem["items"] = [];
                var secondLevelKeys = Object.keys((menuGroupsResponse[firstLevelKeys[i]]));

                for (var j = 0; j < secondLevelKeys.length; j++) {
                    if (secondLevelKeys[j] != "resellerSpecificName" && isSecondLevelApiShown(firstLevelKeys[i], secondLevelKeys[j], stage, menuGroupsResponse, isWidgetUseCase)) {
                        for (var k = 0; k < menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"].length; k++) {

                            if (isThirdLevelApiShown(stage, isWidgetUseCase)) {
                                var thirdLevelItemsMap = {};
                                //thirdLevelItemsMap["title"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["summary"];
                                if (!menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["apiLifeCycle"]) {
                                    thirdLevelItemsMap["title"] = (<>{menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["summary"]}</>);
                                } else {
                                    thirdLevelItemsMap["title"] = (<>{menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["summary"]}</>);
                                    thirdLevelItemsMap["apiLifeCycle"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["apiLifeCycle"];
                                    customItem["title"] = (<>{titleCase(replaceUnderscoreWithSpace(replaceSpace(firstLevelKeys[i])))}</>);
                                }
                                thirdLevelItemsMap["id"] = replaceSpace(menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["summary"]);
                                thirdLevelItemsMap["header"] = titleCase(addSpacesBeforeCaps(secondLevelKeys[j].replaceAll('_', ' ')));
                                thirdLevelItemsMap["firstLevelkey"] = firstLevelKeys[i];
                                thirdLevelItemsMap["secondLevelkey"] = k;
                                thirdLevelItemsMap["jsonSource"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["jsonSource"].replace(/#/g, '');
                                thirdLevelItemsMap["resellerSpecificName"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["resellerSpecificName"];
                                thirdLevelItemsMap["methodType"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["methodType"];
                                thirdLevelItemsMap["path"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["path"];
                                thirdLevelItemsMap["description"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["description"];
                                if (partnerProductMapJson && thirdLevelItemsMap["description"]) {
                                    var productShortNamesInDescription = Object.keys(cybsProductMapJson).filter(key => thirdLevelItemsMap["description"].includes(cybsProductMapJson[key]));
                                    // cybsMisMatchedProductJson variables and logic will be removed when this Mismatched Product Family Names are changed in SPEC
                                    var cybsMisMatchedProductNameKeys;
                                    if (cybsMisMatchedProductJson) {
                                        cybsMisMatchedProductNameKeys = Object.keys(cybsMisMatchedProductJson).filter(key => thirdLevelItemsMap["description"].includes(cybsMisMatchedProductJson[key]));
                                    }
                                    if (cybsMisMatchedProductNameKeys && cybsMisMatchedProductNameKeys.length != 0) {
                                        productShortNamesInDescription.push(...cybsMisMatchedProductNameKeys);
                                    }
                                    productShortNamesInDescription.forEach((productShortName) => {
                                        var mainProdShortName = productShortName && productShortName.includes("--") ? productShortName.split("--")[0] : undefined;
                                        if ((!mainProdShortName && productShortName && partnerProductMapJson.hasOwnProperty(productShortName)) ||
                                            (mainProdShortName && productShortName && partnerProductMapJson.hasOwnProperty(mainProdShortName) && partnerProductMapJson.hasOwnProperty(productShortName))) {
                                            thirdLevelItemsMap["description"] = thirdLevelItemsMap["description"].replaceAll(cybsProductMapJson[productShortName], partnerProductMapJson[productShortName]);
                                            if (cybsMisMatchedProductJson) {
                                                thirdLevelItemsMap["description"] = thirdLevelItemsMap["description"].replaceAll(cybsMisMatchedProductJson[productShortName], partnerProductMapJson[productShortName]);
                                            }
                                        }
                                    });
                                }

                                thirdLevelItemsMap["description"] = replaceOrUpdateBrandName(thirdLevelItemsMap["description"]);

                                thirdLevelItemsMap["hasBodyParams"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["hasBodyParams"];
                                thirdLevelItemsMap["disableProcessorDropDown"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["disableProcessorDropDown"];
                                thirdLevelItemsMap["disableDefaultMerchantCreds"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["disableDefaultMerchantCreds"];
                                thirdLevelItemsMap["authorizationType"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["authorizationType"];
                                thirdLevelItemsMap["enableDownload"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["enableDownload"];
                                thirdLevelItemsMap["x-custom-headers"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["x-custom-headers"];
                                thirdLevelItemsMap["overrideMerchantCredential"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["overrideMerchantCredential"];
                                thirdLevelItemsMap["noAuth"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["noAuth"] ? menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["noAuth"] : false;
                                thirdLevelItemsMap["isClientSideApi"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["isClientSideApi"];
                                thirdLevelItemsMap["sendDisabled"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["sendDisabled"];
                                thirdLevelItemsMap["isJstreeExpansionLimited"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["isJstreeExpansionLimited"];
                                thirdLevelItemsMap["xApiDependencies"] = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["xApiDependencies"];
                                customItem["items"].push(thirdLevelItemsMap);
                                secondLevelKeyMap[firstLevelKeys[i]] = secondLevelKeys[j];
                            }
                        }
                    }
                }

                for (let key in productCategoriesList) {
                    if (!superSet.hasOwnProperty(key)) {
                        superSet[key] = {};
                        superSet[key].id = key+"_mainProduct";
                        superSet[key].title = key.replaceAll("_", " ");
                        superSet[key].icon = 'account-favorite';
                        superSet[key].items = [];
                    }
                    if (productCategoriesList[key].items.includes(firstLevelKeys[i])) {
                        superSet[key].items.push(customItem);
                        break;
                    }
                }
            }
        }

        lhsContents = Object.values(customData).concat(Object.values(superSet));
    }
    return lhsContents;
}

function getDefaultApiFromParentClass(lhsContents,urlIdArray){
    var firstLevelIterator = 0;
    for(;firstLevelIterator<lhsContents.length ;firstLevelIterator++)
    {
        if(lhsContents[firstLevelIterator]["id"] == urlIdArray[0])
        {
            if(!lhsContents[firstLevelIterator]["items"]){
                return lhsContents[firstLevelIterator]["id"];
            }
            else{
                return lhsContents[firstLevelIterator]["items"][0]["id"];
            }
        } else if(lhsContents[firstLevelIterator].items && lhsContents[firstLevelIterator].items.find(obj => obj.id === urlIdArray[0])){
            const idx = lhsContents[firstLevelIterator].items.findIndex(obj => obj.id === urlIdArray[0]);
            if(!lhsContents[firstLevelIterator]["items"][idx]["items"]){
                return lhsContents[firstLevelIterator]["items"][idx]["id"];
            }
            else{
                return lhsContents[firstLevelIterator]["items"][idx]["items"][0]["id"];
            }
        }
    }
    setWindowLocationHash('#');
    return lhsContents[0]["id"];
}

function getDefaultApiFromSubProductFamily(lhsContents,urlIdArray){
    for(var iterator = 0;iterator<lhsContents.length ;iterator++)
    {
        if(lhsContents[iterator]["id"] == urlIdArray[0])
        {
            if(!lhsContents[iterator]["items"]){
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["id"];
            }
            for(var items = 0; items<lhsContents[iterator]["items"].length;items++)
            {
                if(lhsContents[iterator]["items"][items]["header"].toLowerCase().replaceAll(" ","-") == urlIdArray[1])
                {
                    return lhsContents[iterator]["items"][items]["id"];
                }
            }
            setWindowLocationHash('#'+urlIdArray[0]);
            return lhsContents[iterator]["items"][0]["id"];
        } else if(lhsContents[iterator].items && lhsContents[iterator].items.find(obj => obj.id === urlIdArray[0])){
            const idx = lhsContents[iterator].items.findIndex(obj => obj.id === urlIdArray[0]);
            if(!lhsContents[iterator]["items"][idx]){
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["items"][idx]["id"];
            }
            for(var items = 0; items<lhsContents[iterator]["items"][idx]["items"].length;items++)
            {
                if(lhsContents[iterator]["items"][idx]["items"][items]["header"].toLowerCase().replaceAll(" ","-") == urlIdArray[1])
                {
                    return lhsContents[iterator]["items"][idx]["items"][items]["id"];
                }
            }
            setWindowLocationHash('#'+urlIdArray[0]);
            return lhsContents[iterator]["items"][idx]["items"][0]["id"];
        }
    }
    setWindowLocationHash('#');
    return lhsContents[0]["id"];
}

function validateThirdLevelApiName(lhsContents,urlIdArray){
    for(var iterator = 0;iterator<lhsContents.length ;iterator++)
    {
        if(lhsContents[iterator]["id"] == urlIdArray[0])
        {
            if(!lhsContents[iterator]["items"]){
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["id"];
            }
            var secondLevelIterator = 0;
            while(secondLevelIterator < lhsContents[iterator]["items"].length && lhsContents[iterator]["items"][secondLevelIterator]["header"].toLowerCase().replaceAll(" ","-") != urlIdArray[1]){
                secondLevelIterator++;
            }
            var thirdLevelIterator = 0;
            while(secondLevelIterator+thirdLevelIterator < lhsContents[iterator]["items"].length &&
            lhsContents[iterator]["items"][secondLevelIterator+thirdLevelIterator]["header"].toLowerCase().replaceAll(" ","-") == urlIdArray[1]){
                if(lhsContents[iterator]["items"][secondLevelIterator+thirdLevelIterator]["id"] == urlIdArray[2]){
                    return lhsContents[iterator]["items"][secondLevelIterator+thirdLevelIterator]["id"];
                }
                thirdLevelIterator++;
            }
            if(secondLevelIterator < lhsContents[iterator]["items"].length){
                setWindowLocationHash('#'+urlIdArray[0]+'_'+urlIdArray[1]);
                return lhsContents[iterator]["items"][secondLevelIterator]["id"];
            }
            else{
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["items"][0]["id"];
            }
        } else if(lhsContents[iterator].items && lhsContents[iterator].items.find(obj => obj.id === urlIdArray[0])){
            const idx = lhsContents[iterator].items.findIndex(obj => obj.id === urlIdArray[0]);
            if(!lhsContents[iterator]["items"][idx]){
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["items"][idx]["id"];
            }
            var secondLevelIterator = 0;
            while(secondLevelIterator < lhsContents[iterator]["items"][idx]["items"].length && lhsContents[iterator]["items"][idx]["items"][secondLevelIterator]["header"].toLowerCase().replaceAll(" ","-") != urlIdArray[1]){
                secondLevelIterator++;
            }
            var thirdLevelIterator = 0;
            while(secondLevelIterator+thirdLevelIterator < lhsContents[iterator]["items"][idx]["items"].length &&
            lhsContents[iterator]["items"][idx]["items"][secondLevelIterator+thirdLevelIterator]["header"].toLowerCase().replaceAll(" ","-") == urlIdArray[1]){
                if(lhsContents[iterator]["items"][idx]["items"][secondLevelIterator+thirdLevelIterator]["id"] == urlIdArray[2]){
                    return lhsContents[iterator]["items"][idx]["items"][secondLevelIterator+thirdLevelIterator]["id"];
                }
                thirdLevelIterator++;
            }
            if(secondLevelIterator < lhsContents[iterator]["items"][idx]["items"].length){
                setWindowLocationHash('#'+urlIdArray[0]+'_'+urlIdArray[1]);
                return lhsContents[iterator]["items"][idx]["items"][secondLevelIterator]["id"];
            }
            else{
                setWindowLocationHash('#'+urlIdArray[0]);
                return lhsContents[iterator]["items"][idx]["items"][0]["id"];
            }
        }
    }
    setWindowLocationHash('#');
    return lhsContents[0]["id"];
}

function initiateDeepLink(lhsContents,selectedId){
    navigateToSections(false,lhsContents,selectedId);
    LoadJsonData(false);
}


export default getContentDetailsFromLHSJsonAndPopulateDataStore;
export {getContentDetailsFromLHSJsonAndPopulateDataStore,getLHSBasedOnHostName,navigateToSections,getLHSJsonData,getHostName,getDefaultApiFromParentClass,getDefaultApiFromSubProductFamily,validateThirdLevelApiName,initiateDeepLink,clearResponseFields};